export default "__VITE_ASSET__fc506135__"